// @flow
import { prop } from 'ramda';

import { emptyObject } from 'app/common/lib/empty';
import mailFilter, { readyToUse, onlyMail } from 'app/components/common/reports/filters/mail';
import { getValue } from 'app/common/ui-components/filter';

import type { FilterParams } from '../FilterParams.type';
import type { RequestOptions } from './types';


type State = { [key: string]: any }

const generateParamsOptions = (state: State, filterParams: FilterParams): [RequestOptions, boolean] => {
  const email: string | void = filterParams && prop('email', filterParams);

  const [mailFilterValue] = getValue(mailFilter, state);

  const onlymail = Boolean(email && onlyMail(mailFilterValue));
  const mailReady = readyToUse(mailFilterValue);
  const options = mailReady ? {
    send_to_email: email,
  } : emptyObject;

  return [options, onlymail];
};

export default generateParamsOptions;
